import React from 'react'
import { ContactForm } from './ContactForm'

// #contact — nav anchor + section wrapper mirroring INSPINIA's landing markup.
export const ContactSection = () => {
  return (
    <section className="section-custom" id="contact">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <span className="text-muted rounded-3 d-inline-block">Get a quote</span>
            <h2 className="mt-3 fw-bold mb-5">
              Talk to the <mark className="fst-italic">Gatekeeper</mark> team
            </h2>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-xxl-8 col-lg-10">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  )
}
